import "./AchievementPopup.scss";
import {achievementMessage, AchievementName} from "../models/AchievementName";

export function achievementPopupTemplate(id: string, name: AchievementName, value: number | null): string {
    const achievement = achievementTemplate(name, value);
    return `
        <div id="${id}" class="achievement-popup fadeIn animated">
            ${achievement}
        </div>
    `;
}

export function achievementTemplate(name: AchievementName, value: number | null) {
    const message = achievementMessage(name);
    const pointsText = value == null ? "" : value.toString();
    return `
        <div class="achievement">
            <div class="achievement-icon">
                <div class="points">${pointsText}</div>
                <i class="icon-trophy2"></i>
            </div>
            <div class="achievement-message">
                ${message}
            </div>
        </div>
    `;
}
